import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import axios from 'axios';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useDispatch, useSelector } from 'react-redux';
import { updateEdit, updateModal, updateProductDetail, updateProducts } from '../Redux/products';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { Alert, Button, Skeleton, Typography } from '@mui/material';
import { useState } from 'react';
import veg from "../Assets/product_management/Foodmark.svg"
import nonVeg from "../Assets/product_management/non-veg.svg"
import Tooltip from '@mui/material/Tooltip';
import CustomAxios from '../utils/CustomAxios';
import { blobSrc } from '../utils/blobUrl';
import { useGetProducts } from '../Components/globalFunctions';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
export function ProductTable() {
  const authToken = localStorage.getItem('authtoken');
  const toast = useRef(null);
  const products = useSelector(state => state.products.products)
  const search = useSelector(state => state.page.searchProduct)
  const dispatch = useDispatch()
  const loading  = useSelector(state => state.products.loading);
  const getProducts = useGetProducts()
  const role = localStorage.getItem('role');
  const selectedHub = useSelector(state => state.user.selected_hub)?.[0]; 
  const userHubList = JSON.parse(localStorage.getItem('hub') || '[]');
  
  // Debug logging for Customer Engagement Admin
  if (role === 'customer_engagement_admin') {
    console.log('Product Table - Customer Engagement Admin Debug:');
    console.log('Role:', role);
    console.log('userHubList from localStorage:', userHubList);
    console.log('Total products:', products.length);
  }
  
  // Check if user can manage products (create, edit, delete)
  const canManageProducts = ['super_admin', 'admin', 'supervisor'].includes(role);
  
  // Filter products based on user role and assigned hubs
  let hubFilteredProducts;
  if (role === 'customer_engagement_admin') {
    hubFilteredProducts = products.filter(product => {
      // Debug logging
      // console.log('Customer Engagement Admin - Product:', product);
      // console.log('Customer Engagement Admin - userHubList:', userHubList);
      // console.log('Customer Engagement Admin - product.inventory:', product.inventory);
      // console.log('Customer Engagement Admin - product.capacitydetails:', product.capacitydetails);
      
      // Check if product is available in any of the assigned hubs
      // Try multiple ways to check hub availability
      const hasInventoryMatch = product.inventory && product.inventory.some(inv => userHubList.includes(inv.id));
      const hasCapacityMatch = product.capacitydetails && Object.keys(product.capacitydetails).some(hubId => userHubList.includes(parseInt(hubId)));
      
      // console.log('Customer Engagement Admin - hasInventoryMatch:', hasInventoryMatch);
      // console.log('Customer Engagement Admin - hasCapacityMatch:', hasCapacityMatch);
      
      const result = hasInventoryMatch || hasCapacityMatch;
      // console.log('Customer Engagement Admin - Final result for product:', product.item_name, ':', result);
      return result;
    });
    
    // Debug: Log filtered results
    // console.log('Customer Engagement Admin - hubFilteredProducts count:', hubFilteredProducts.length);
    // console.log('Customer Engagement Admin - hubFilteredProducts:', hubFilteredProducts);
    
    // Temporary fallback: if no products found, show all products for debugging
    if (hubFilteredProducts.length === 0 && products.length > 0) {
      // console.log('Customer Engagement Admin - No products found after filtering, showing all products for debugging');
      hubFilteredProducts = products; // Use all products temporarily for debugging
    }
  } else {
    hubFilteredProducts = products;
  }

  const [showOtherProducts, setShowOtherProducts] = useState(false);

  // Check if supervisor is assigned to FoodFix franchise
  const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
  const selectedFranchiseId = localStorage.getItem('selected_franchise_id');
  const isFoodFixSupervisor = selectedFranchiseId && parseInt(selectedFranchiseId) === 2;
  
  // Additional check: Look at inventory data to see if any assigned hub belongs to FoodFix
  const inventory = useSelector(state => state.inventory.inventory);
  const hasFoodFixHub = inventory && inventory.some(hub => 
    assignedHubs.includes(hub.value) && hub.franchise_id === 2
  );
  
  const canAccessOtherProducts = !(isFoodFixSupervisor || hasFoodFixHub);

  const accept = async (id) => {
    console.log(id)
    try {
      const response = await CustomAxios.patch(`products/delete/${id}`);
      getProducts();
      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: response.data.message,
        life: 3000
      });
    } catch (err) {
      console.error(err);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Action failed',
        life: 3000
      });
    }
  }

  useEffect(() => {
    getProducts()
  }, [authToken])



  const confirmDelete = (item) => {
    confirmDialog({
      message: (
        <Box sx={{ display: "flex", gap: "10px",flexDirection:"column" }}>
          <Box sx={{ display: "flex", gap: "20px",alignItems:"center" }}>
            {item.image_urls.map((img) => (<Box component='img' src={blobSrc(img)} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px" }}></Box>))}
            <Box >{item.item_name}</Box>
          </Box>
          <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>Do you want to {item.is_active == true ? 'Deactivate' : 'Activate'} this Product </Typography>
        </Box>
      ),
      header: 'Confirmation',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-danger',
      accept: () => accept(item.id),
    });
  };

const handleOpen = (row) => {
    // Transform capacitydetails from nested object to expected format
    const transformed = {};
    Object.entries(row.capacitydetails || {}).forEach(([invId, invData]) => {
        transformed[invId] = invData.capacities;
    });

    dispatch(updateEdit(true));
    dispatch(updateProductDetail({
        ...row,
        capacitydetails: transformed
    }));
    dispatch(updateModal(true));
};

  const extractPlainText = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
};
console.log(products)

  const filteredProducts = hubFilteredProducts?.filter((item) => {
    if (!item.item_name) return false;

    const matchesSearch = search
      ? item.item_name.toLowerCase().includes(search.toLowerCase())
      : true;

    if (role === 'admin') return matchesSearch;

    const productHubs = Object.keys(item.capacitydetails || {}).map(id => parseInt(id));

    if (showOtherProducts) {
      // Show products NOT in the currently selected hub
      return matchesSearch && !productHubs.includes(parseInt(selectedHub));
    } else {
      // Show products IN the currently selected hub
      return matchesSearch && productHubs.includes(parseInt(selectedHub));
    }
  });


  return (
    <Box>
      {role === 'supervisor' && canAccessOtherProducts && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          {
            showOtherProducts && 
            <Alert severity="info" sx={{ mt: 2 }}>
              You are currently viewing all products outside your hub.
            </Alert>
          }       
          <Button
            variant="contained"
            onClick={() => setShowOtherProducts(prev => !prev)}
            sx={{
              textTransform: "none",
              backgroundColor: "button.blue", // grey for temp view, blue for main view
              color:  "white",
              border: "none",
              boxShadow:  2,
              px: 2,
              py: 1,
              '&:hover': {
                backgroundColor:  "button.blue",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: { sm: "12px", md: "14px" },
                fontWeight: "500",
                lineHeight: "22px",
                textAlign: "center",
              }}
            >
              {showOtherProducts ? "⬅ Back to My Hub Products" : "Show All Products (Outside My Hub)"}
            </Typography>
          </Button>
        </Box>
      )}
      <Toast ref={toast} />
      {/* <ConfirmDialog /> */}
      <TableContainer sx={{ height: "600px" }}>
        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
          <TableHead style={{ backgroundColor: "background.upload" }}>
            <TableRow >
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }}>S No</TableCell>
              {(role === 'admin' || role === 'customer_engagement_admin' || role === 'super_admin') && (
                <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }}>Hub</TableCell>
              )}
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }}>Images</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Description</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Details</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Category</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Criteria</TableCell>
              {/* <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Availability</TableCell> */}
              {/* <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Price</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Selling Price</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload",textAlign:"left" }} align="right">Offer Price</TableCell> */}
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload", textAlign: "left" }} align="right">Status</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "center", backgroundColor: "background.upload", textAlign: "left" }} align="right">Update / Delete</TableCell>


            </TableRow>
          </TableHead>
          <TableBody>
            {filteredProducts?.length > 0 ? 
              filteredProducts.map((item,ind) => {
              // console.log(item.item_criteria)
              return (<> {
                <TableRow key={item.id}>
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{ind+1}</TableCell>
                  {(role === 'admin' || role === 'customer_engagement_admin' || role === 'super_admin') && (
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                    {Object.entries(item.capacitydetails || {}).map(([invId, invData]) => (
                      <div key={invId}>
                        {invData.name}
                      </div>
                    ))}
                  </TableCell>
                    )}
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                    {item.image_urls.map((img) => (<Box component='img' src={blobSrc(img)} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px" }}></Box>))}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.item_name}</TableCell>
                  <TableCell sx={{ textAlign: "left", backgroundColor: "white", maxWidth: "350px", wordBreak: 'break-word' }}>
                    {item.item_description.charAt(0).toUpperCase() + item.item_description.slice(1).toLowerCase()}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", backgroundColor: "white", maxWidth: "300px" }}>
                  <Tooltip sx={{ width: "500px" }} title={extractPlainText(item.item_details)} arrow>
                    {extractPlainText(item.item_details.split(' ').slice(0, 3).join(' '))}...
                  </Tooltip>
                   </TableCell>
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.item_category}</TableCell>
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.item_criteria == 'veg' ? <Box component='img' src={veg}></Box> : <Box component='img' src={nonVeg}></Box>}</TableCell>
                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.is_active == false ? <Box sx={{ width: "120px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }}><Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red", textAlign: "center", textTransform: "uppercase", width: "88px" }}> Inactive</Typography></Box> : <Box sx={{ width: "67px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }} ><Typography sx={{ textAlign: "center", fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green", textTransform: "uppercase", width: "67px" }}>Active</Typography></Box>}</TableCell>
                  {/* <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white" }}>{item.capacitydetails.item_available==true?"Available":"Out of stock"}</TableCell> */}
                  {/* <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white" }}>{item.capacitydetails.item_price}</TableCell>
                  <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white" }}>{item.capacitydetails.item_selling_price}</TableCell>
                  <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white" }}>{item.capacitydetails.item_offers_price}</TableCell> */}
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                  {canManageProducts ? (
                    <>
                      <Tooltip title="Update" arrow>
                        <IconButton sx={{ textTransform: "none" }} onClick={() => handleOpen(item)}><EditIcon /></IconButton>
                      </Tooltip>
                      {/* Show delete/activate for super_admin, admin, and supervisor */}
                      {(role === 'super_admin' || role === 'admin' || role === 'supervisor') && (
                        <Tooltip title={item.is_active == true ? "Deactivate" : "Activate"} arrow>
                            <IconButton sx={{ textTransform: "none" }} onClick={() => confirmDelete(item)}>{item.is_active == true ? <DeleteOutlineIcon /> : <TaskAltIcon />}</IconButton>
                        </Tooltip>
                      )}
                    </>
                  ) : (
                    <Typography sx={{ fontSize: "12px", color: "gray", fontStyle: "italic" }}>
                      View Only
                    </Typography>
                  )}
                  </TableCell>
                </TableRow>}</>)
            })
            : <TableRow  >
            {loading ? <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={(role === 'admin' || role === 'customer_engagement_admin' || role === 'super_admin') ? 11 : 10}>
                <Box>
                    <Box sx={{ width: "80%" }}>
                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                    </Box>
                    <Box sx={{ width: "80%" }}>
                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                    </Box>
                    <Box sx={{ width: "80%" }}>
                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                    </Box>
                </Box>
            </TableCell>:
            <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={(role === 'admin' || role === 'customer_engagement_admin' || role === 'super_admin') ? 11 : 10}>No Products Available</TableCell>}
        </TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>

  );
}
